import { Delay } from "components/atoms/Delay";
import { fortuneTellerIcon } from "components/templates/無料占いBot";
import { Balloon } from "features/無料占いBot/components/Balloon";
import { Confirmable } from "features/無料占いBot/components/Confirmable";
import { useFormContext } from "react-hook-form";
import { eventName, eventAction, useGaEvent } from "shared/hooks/useGaEvent";

const fieldName = "bloodtype";

export const SelectBloodType = () => {
  const { register, watch } = useFormContext();
  const { sendEvent } = useGaEvent();

  const [value, themeId, answerId] = watch([fieldName, "theme", "answer"]);

  const onClickConfirm = () => {
    sendEvent({
      eventName: eventName.freeFortuneChatBot,
      eventAction: eventAction.freeFortuneChatBot.confirmBloodType,
      eventParams: {
        theme_id: themeId,
        answer_id: answerId,
      },
    });
  };

  return (
    <Confirmable
      name={fieldName}
      icon={fortuneTellerIcon}
      text={`血液型は${value}型でお間違いありませんか？`}
      onClickConfirm={onClickConfirm}
    >
      <Delay icon={fortuneTellerIcon}>
        <Balloon icon={fortuneTellerIcon}>
          {`ありがとうございます😌\nでは次に【血液型】を教えてください。`}
        </Balloon>

        <div tw="justify-end mb-4 flex">
          <select {...register(fieldName)} tw="border-card">
            <option>血液型選択</option>
            <option>A</option>
            <option>B</option>
            <option>O</option>
            <option>AB</option>
          </select>
        </div>
      </Delay>
    </Confirmable>
  );
};
